var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"line-wrapper",staticStyle:{"position":"relative"}},[(_vm.noDateShow)?_c('div',{staticClass:"noDateShow"},[_vm._v("暂无数据")]):_vm._e(),_c('div',{staticClass:"line-content",attrs:{"id":_vm.id}})])])}
var staticRenderFns = []

export { render, staticRenderFns }